/*
 * @note このファイルは.prettierignoreで無視対象ディレクトリにある
 */

//------------
// エラー
//------------
export const WINDOW_ERR_GIVE_IN_TIME            = "エラーが発生しました。時間をおいて再度お試しください";
export const WINDOW_ERR_INPUT_FORMAT            = "エラー：入力形式に誤りがあります";
export const WINDOW_ERR_INPUT_CONTENTS          = "エラー：入力内容を確認してください";
export const WINDOW_ERR_PASSWORD_RESET_EMAIL    = "エラー：もう一度、パスワード再設定メールを受信してください";
export const WINDOW_ERR_PASSWORD_FORMAT         = "エラー：新しいパスワードを複雑なものに変更してください";
export const WINDOW_ERR_MAIL_FORMAT             = "エラー：メールアドレスの形式が正しくありません";
export const WINDOW_ERR_SAVE                    = "エラー：保存に失敗しました。しばらく待ってから再度お試しください";
export const WINDOW_ERR_VALIDATION              = "エラー：入力内容が制限を超えています。タグや対象作品の件数、各項目の文字数を確認してください";
export const WINDOW_ERR_UPDATE                  = "エラー：更新に失敗しました。ブラウザを更新して再度お試しください";
export const WINDOW_ERR_USER_INFO               = "ユーザー情報に誤りがあります。再度、登録済みのメールアドレスにパスワードリセットメールを送信してください";
export const WINDOW_ERR_LIMIT_INPUT             = "入力回数の制限を超えました。しばらく待ってから再度お試しください";
export const WINDOW_ERR_LIMIT_MAIL              = "メールの送信回数が上限に達しました。しばらく時間をおいてからお試しください。";
export const WINDOW_ERR_NETWORK                 = "ネットワークエラーが発生しました。通信環境のよいところでお試しください";
export const WINDOW_ERR_IMAGE_FORMAT            = "エラー：対応していない画像形式です（jpg, png, gif, webpのみ利用できます）";
export const WINDOW_ERR_IMAGE_SIZE              = "エラー：画像サイズは5MB以内にしてください";
export const WINDOW_ERR_IMAGE_UPLOAD            = "エラー：画像のアップロードに失敗しました。しばらく待ってから再度お試しください";
export const WINDOW_ERR_IMAGE_NOT_READY         = "エラー：記事の準備が完了していません。少し時間をおいてから再度お試しください";

//------------
// 警告
//------------
export const WINDOW_WARN_SAME_NAME              = "現在の名前と同じです";
export const WINDOW_WARN_FAVORIT                = "ログインするといいねすることができます！";
export const WINDOW_WARN_FREEZE_ACCOUNT         = "アカウントが凍結されています。\n詳細は運営までお問合せください";
export const WINDOW_WARN_REGISTERED             = "既に登録されています";
export const WINDOW_WARN_RESISTERED_MAIL        = "このメールアドレスはすでに使用されています";
export const WINDOW_WARN_WEEK_PASSWORD          = "パスワードが脆弱です。6文字以上で入力してください";

//------------
// 完了
//------------
export const WINDOW_MSG_MAIL_SENT                   = "現在登録中のメールアドレスに、確認メールを送信しました";
export const WINDOW_MSG_PASSWORD_RESET_MAIL_SENT    = "ご登録のメールアドレスに、数分以内にパスワード再設定のメールが送られます。\n受信したメールをご確認ください";
// export const WINDOW_PASSWORD_RESET_MAIL_SENT_MSG    = "数分以内にパスワード再設定のメールが送られます。受信したメールをご確認ください";
export const WINDOW_MSG_NEW_MAIL_SENT               = "新しいメールアドレスにメールを送信しました\n（メールアドレスの変更を完了するには、受信メール中のURLをクリックしてください）";
export const WINDOW_MSG_COMPLETE_DELETE_ACCOUNT     = "アカウントを削除しました。\nご利用いただき、誠にありがとうございました";
export const WINDOW_MSG_PASSWORD_RESET_MSG          = "パスワードをリセットしました";
export const WINDOW_MSG_PASSWORD_CHANGE_MSG         = "パスワードを変更しました";
export const WINDOW_MSG_UPDATE                      = "更新しました";
export const WINDOW_MSG_LOGOUT                      = "ログアウトしました";
export const WINDOW_MSG_REAUTH                      = "再認証が完了しました";

//------------
// 確認
//------------
export const WINDOW_CONF_DELETE_ACCOUNT         = "アカウントを削除します\nよろしいですか？";
export const WINDOW_CONF_DELETE_GRAPH           = "グラフを削除します。\nよろしいですか？";
export const WINDOW_CONF_DELETE_LINE            = "選択した行を削除します。\nよろしいですか？";
export const WINDOW_CONF_DELETE_COLUMN          = "選択した列を削除します。\nよろしいですか？";
export const WINDOW_CONF_DELETE_POST            = "投稿中の分析記事を削除します。削除すると元に戻すことはできません。\nよろしいですか？";
export const WINDOW_CONF_DELETE_DRAFT           = "選択した下書きを削除します。\nよろしいですか？";
export const WINDOW_CONF_RESET_NODE             = "このノードとその下にあるノードがリセットされます。\nよろしいですか？";
export const WINDOW_CONF_RESET_TIMELINE_VALUE   = "表示形式を変更すると、入力済みの開始・終了値がリセットされます。\nよろしいですか？";
export const WINDOW_CONF_CANCEL_UPDATE          = "更新をキャンセルしますか？";
export const WINDOW_CONF_MOVE_MAIL_AUTH         = "メールアドレスが未認証です。先にメールアドレス認証をお済ませください。\nメール認証ページへ移動してもよろしいですか？";
export const WINDOW_CONF_SEND_MAIL_PASSWORD     = "ご登録中のメールアドレスにパスワード再設定のメールを送ります。\nよろしいですか？";
export const WINDOW_CONF_POST                   = "この分析を投稿します。よろしいですか？\n（投稿した記事はいつでも編集・削除できます）";
export const WINDOW_CONF_NO_SAVE                = "保存されていないデータは削除されます。\nよろしいですか？";
